export const I18CONFIG = {
  LOCALE: 'en',
  FALLBACK_LOCALE: 'de',
  CURRENCY: 'EUR'
}